"use client";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  EffectCoverflow,
  Thumbs,
} from "swiper/modules";
import React, { useState } from "react";

const Slider = ({
  children,
  paginated = false,
  navigation = false,
  autoPlay = false,
  displayThumbnails = false,
  slidesPerView = 1,
  delay = 5000,
  onClick = null,
}) => {
  let swiperInstance;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const childCount = React.Children.count(children);
  if (!childCount) return null;
  if (childCount === 1) return children;
  const modules = [];

  if (paginated) modules.push(Pagination);
  if (navigation) modules.push(Navigation);
  if (autoPlay) modules.push(Autoplay);
  if (displayThumbnails) modules.push(Thumbs);
  const isCrossFade = slidesPerView > 1;
  if (isCrossFade) modules.push(EffectCoverflow);

  return (
    <>
      <Swiper
        navigation={navigation}
        centeredSlides={false}
        pagination={{
          dynamicBullets: navigation,
          clickable: false,
        }}
        loop={false}
        spaceBetween={0}
        modules={modules}
        slidesPerView={slidesPerView}
        autoplay={{
          delay,
          stopOnLastSlide: false,
        }}
        effect={slidesPerView > 1 ? "" : "slide"}
        onSwiper={(swiper) => (swiperInstance = swiper)}
        thumbs={{ swiper: thumbsSwiper }}
      >
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            return (
              <SwiperSlide
                key={`slider-${index}`}
                onClick={onClick ? () => onClick(index) : null}
              >
                {child}
              </SwiperSlide>
            );
          }
          return null;
        })}
      </Swiper>
      {childCount && displayThumbnails && (
        <Swiper
          modules={[Thumbs, Navigation]}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          slidesPerView={Math.min(childCount, 6)}
          spaceBetween={10}
          className="swiper-thumbs-container"
        >
          {React.Children.map(children, (child, index) =>
            React.isValidElement(child) ? (
              <SwiperSlide key={`thumb-${index}`}>{child}</SwiperSlide>
            ) : null,
          )}
        </Swiper>
      )}
    </>
  );
};

export default Slider;
